import { courseApi } from '@store';
import { useEffect, useState } from 'react';
import { useIndexedDB } from 'react-indexed-db-hook';

import { useOnlineStatusDetector } from './useOnlineStatusDetector';

export const useOfflineModules = () => {
  const { isOnline } = useOnlineStatusDetector();
  const { getAll } = useIndexedDB('modules');
  const [offlineModules, setOfflineModules] = useState();
  const { modules, refetch: refetchModules } = courseApi.useGetAllModulesQuery(
    undefined,
    {
      selectFromResult: ({ data }) => ({
        modules: data?.data?.modules,
      }),
      skip: !isOnline,
    }
  );

  useEffect(() => {
    const init = async () => {
      const allModules = await getAll();
      setOfflineModules(allModules);
    };
    init();
  }, [isOnline]);

  if (!isOnline) {
    return {
      isOffline: true,
      modules: offlineModules,
      refetchModules: () => {},
    };
  }

  return { isOffline: false, modules, refetchModules };
};
